var exports = {
  "k": "x234b8571--de4361--container",
};

module.exports = exports;
